export const home = [{
    path: '/home',
    name: "Home",
    component: () =>
        import ("../views/home/index.vue"),
    meta: { title: '首页' },
}]